import { render, staticRenderFns } from "./BookingFormEdit2.vue?vue&type=template&id=5b9013f0&"
import script from "./BookingFormEdit2.vue?vue&type=script&lang=js&"
export * from "./BookingFormEdit2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports